<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Incident Documents"
      text="Upload Incident Documents"
      class="mb-0"
    > 
      <form>
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                :max-size-in-mb="2"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                accept-type=".pdf"    
                extension="ext:pdf"         
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    inject: ['$validator'],
    props: {
      employeeUid: {
        type: String, 
        required: true,
      },
    },
    data () {
      return {
        incidentId: null,
        progressing: false,
        dialog: false,
        file: null,
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },
    methods: {
      toggleDialog (incident) {
        this.incidentId = incident.id

        this.dialog = true
      },
      submitForm () {
        this.progressing = true

        this.$api.incidents().upload(this.incidentId, this.file.formData)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('uploaded')
              this.$snack({ message: 'Documents uploaded' })

              this.dialog = false
            }
          })
          .catch(error => {
            if (error.response.status === 405) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })      
            }
          })
          .then(() => {
            this.progressing = false
          })
      },
    },
  }
</script>
